import { DifferenceType } from '@modules-deprecated/bankReconciliation/types'

export const differenceTypeTKeys: Record<DifferenceType, string> = {
  overpayment: 'bill.payment_reconcile.difference.overpayment',
  underpayment: 'bill.payment_reconcile.difference.underpayment',
  bankFee: 'bill.payment_reconcile.difference.bankFee',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  exchange_rate: 'bill.payment_reconcile.difference.exchange_rate',
}
